module.exports = __webpack_public_path__ + "img/3401c06.jpg";